import { render, staticRenderFns } from "./GenericTabItem.vue?vue&type=template&id=4d33bfc3&scoped=true&"
import script from "./GenericTabItem.vue?vue&type=script&lang=js&"
export * from "./GenericTabItem.vue?vue&type=script&lang=js&"
import style0 from "./GenericTabItem.vue?vue&type=style&index=0&id=4d33bfc3&lang=sass&scoped=true&"
import style1 from "./GenericTabItem.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d33bfc3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VCol,VRow,VSlideGroup,VSlideItem})
